export default "__VITE_ASSET__DRZ5eTRG__"